<dff-sidenav-menu
    [items]="menuItems$ | async"
    (itemClick)="itemClick.emit($event)"
    id="forsyningweb-sidenav-menu"
    role="list"
></dff-sidenav-menu>
